import { useEffect, useMemo } from "react";

import { IApiCorbansResponse, useApiCorbans } from "@hooks/api/auth";
import { featureFlags } from "@settings";

export type CorbanOption = IApiCorbansResponse["results"][0] & {
  name: string;
};

type UseOptionsProps = {
  skipFetch?: boolean;
};

export const useCorbansOptions = ({ skipFetch }: UseOptionsProps = {}) => {
  const [fetchCorbans, { data, ...state }] = useApiCorbans();

  const parsedCorbans = useMemo(() => {
    const corbans = data?.results.map((corban) => ({
      ...corban,
      name: corban.fantasy_name || corban.corban_name,
    }));
    if (!featureFlags.enableCorrespondenteBanqueiro) {
      return corbans;
    }
    const actualCorban = corbans?.filter((corban) => {
      const url = corban?.url;
      return url && url === location.origin;
    });
    return actualCorban;
  }, [data?.results]);

  useEffect(() => {
    const fetch = async () => {
      try {
        await fetchCorbans();
      } catch {
        // do nothing
      }
    };

    if (!skipFetch) {
      void fetch();
    }
  }, [skipFetch, fetchCorbans]);

  return {
    options: parsedCorbans ?? [],
    ...state,
  };
};
